<template>
  <div class="footer-bottom">
    <img src="/static_img/skinc/footer/Logo_ENG.png" class="footer-logo" alt="SK Logo" />

    <div class="footer-text">
      26, JONG-RO, JONGRO-GU, SEOUL, 03188, REPUBLIC OF KOREA<br />
      COPYRIGHT Ⓒ BY SK INC. ALL RIGHTS RESERVED
    </div>
  </div>
</template>

<script>
export default {
  name: 'FooterBottom'
};
</script>

<style scoped>
.footer-bottom {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 32px 0;
  border-top: 1px solid #dddddd;
  font-size: 12px;
  color: #aaa;
  flex-wrap: wrap;
}

.footer-logo {
  height: 56px;
}

.footer-text {
  text-align: right;
  font-size: 14px;
  line-height: 24px;
  color: #727272;
}

@media (max-width: 768px) {
  .footer-bottom {
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
  }

  .footer-text {
    text-align: left;
  }
}
</style>
